import { render } from "./whatsapp-compliance-keywords.vue?vue&type=template&id=4c9fd1bc&scoped=true"
import script from "./whatsapp-compliance-keywords.vue?vue&type=script&lang=js"
export * from "./whatsapp-compliance-keywords.vue?vue&type=script&lang=js"

import "./whatsapp-compliance-keywords.vue?vue&type=style&index=0&id=4c9fd1bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9fd1bc"]])

export default __exports__